import { AppRoutes } from '../routes/AppRoutes.jsx';

export function App() {
  return <AppRoutes />;
}
